import { T_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS } from './TYPES'

const FR_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS: T_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS =
  {
    TITLE: "Période d'essai",
    DESCRIPTION:
      "Votre période d'essai se termine le {subscriptionExpireOn}. Veuillez contacter un adulte pour prolonger votre abonnement.",
    CTA_TEXT: 'Fermer'
  }

export default FR_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS
